import { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

const MyTabs = ({ tabs = [], onTabIdChange=null }) => {
  const [_selectedTabIndex, setSelectedTabIndex] = useState(0);

  useEffect(() => {
    if (tabs.length === 0) return;
    // force select first tab
    onTabChange(null, 0);
  }, []);


  const onTabChange = (event, index) => {
    setSelectedTabIndex(index);
    if (onTabIdChange) {
        onTabIdChange(tabs[index].id);
    }
  };

  return (<Tabs value={_selectedTabIndex} onChange={onTabChange}>
    {tabs.map((tab) => (
        <Tab id={tab.id} label={tab.label} />
    ))}
  </Tabs>);
};

export default MyTabs;
